<script setup lang="ts">
/**
 * Shimmer placeholder for the LLM marking wait (PRD PE-8.3).
 *
 * Sized by prop because the shimmer class alone sets no dimensions, and a
 * zero-height skeleton is invisible — the exact failure this is meant to
 * prevent. `aria-hidden` because a screen reader should hear the live status
 * text, not a decorative block.
 */
withDefaults(defineProps<{ width?: string; height?: number }>(), {
  width: "100%",
  height: 12,
});
</script>

<template>
  <div
    class="rl-skeleton"
    :style="{ width, height: `${height}px` }"
    aria-hidden="true"
  />
</template>
